/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import {
  ProjectChildrenFragmentDoc,
  ProjectFragmentDoc
} from "../../projects/graphql/fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type FavoritesProjectQueryVariables = Exact<{ [key: string]: never }>

export type FavoritesProjectQuery = {
  __typename: "Query"
  project?: {
    __typename: "Project"
    id: string
    title: string
    description?: string | null
    position: number
    priceList?: string | null
    inflationSurcharge?: number | null
    createdAt: string
    updatedAt: string
    lastChanged?: string | null
    hasClarificationRequest?: boolean | null
    ui?: { __typename: "ProjectUI"; color?: string | null } | null
    lastChangedBy?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
    phase?: {
      __typename: "ProjectPhase"
      id: string
      value: string
      label: string
    } | null
    team?: { __typename: "ProjectTeamID"; id: string } | null
  } | null
}

export type FavoritesQueryVariables = Exact<{ [key: string]: never }>

export type FavoritesQuery = {
  __typename: "Query"
  project?: {
    __typename: "Project"
    id: string
    children?: Array<
      | {
          __typename: "Floor"
          id: string
          label?: string | null
          position: number
          createdAt: string
          updatedAt: string
          remark?: string | null
          hasClarificationRequest?: boolean | null
          children?: Array<{
            __typename: "Room"
            id: string
            label?: string | null
            number: string
            area?: number | null
            volume?: number | null
            utilization?: string | null
            height?: number | null
            personsNumber?: number | null
            airVolumePerArea?: number | null
            airVolumePerPerson?: number | null
            remark?: string | null
            sup?: number | null
            oda?: number | null
            eta?: number | null
            eha?: number | null
            tra?: number | null
            rca?: number | null
            ida?: number | null
            sec?: number | null
            soundPressureLevel?: number | null
            position: number
            createdAt: string
            updatedAt: string
            hasClarificationRequest?: boolean | null
            children?: Array<{
              __typename: "ProductPosition"
              id: string
              label?: string | null
              variantKey: string
              configurationKey?: string | null
              remark?: string | null
              quantity: number
              position: number
              displayPosition?: string | null
              isAlternative?: boolean | null
              price?: number | null
              priceGroup?: string | null
              hasClarificationRequest?: boolean | null
              references?: Array<{
                __typename: "ProductPositionInstallationReference"
                id: string
                title?: string | null
                permalink: string
                position: number
              }> | null
              addons?: Array<{
                __typename: "ProductPositionAddon"
                id: string
                variantKey: string
                parentProductType: string
              }> | null
              dimensioning?: {
                __typename: "ExternalDimensioningResult"
                transactionId: string
                environmentalVars?: Array<any> | null
                variantKeyData?: any
                dllVersion?: string | null
                language?: string | null
                technicalData?: Array<
                  | {
                      __typename: "ExternalDimensioningTechnicalDataDllVersion"
                      dllVersion: string
                    }
                  | {
                      __typename: "ExternalDimensioningTechnicalDataTable"
                      header?: Array<string> | null
                      content?: any
                      summary?: string | null
                      type?: string | null
                    }
                > | null
                technicalInput?: Array<{
                  __typename: "ExternalDimensioningTechnicalInput"
                  name: string
                  label?: string | null
                  unit?: string | null
                  value?: any
                  userSelected: boolean
                }> | null
                supplementaryText?: Array<{
                  __typename: "ExternalDimensioningSupplementaryText"
                  text: string
                }> | null
                transferData?: {
                  __typename: "ExternalDimensioningTransferData"
                  origin?: string | null
                } | null
              } | null
            }> | null
          }> | null
        }
      | {
          __typename: "ProductPosition"
          id: string
          label?: string | null
          variantKey: string
          configurationKey?: string | null
          remark?: string | null
          quantity: number
          position: number
          displayPosition?: string | null
          isAlternative?: boolean | null
          price?: number | null
          priceGroup?: string | null
          hasClarificationRequest?: boolean | null
          references?: Array<{
            __typename: "ProductPositionInstallationReference"
            id: string
            title?: string | null
            permalink: string
            position: number
          }> | null
          addons?: Array<{
            __typename: "ProductPositionAddon"
            id: string
            variantKey: string
            parentProductType: string
          }> | null
          dimensioning?: {
            __typename: "ExternalDimensioningResult"
            transactionId: string
            environmentalVars?: Array<any> | null
            variantKeyData?: any
            dllVersion?: string | null
            language?: string | null
            technicalData?: Array<
              | {
                  __typename: "ExternalDimensioningTechnicalDataDllVersion"
                  dllVersion: string
                }
              | {
                  __typename: "ExternalDimensioningTechnicalDataTable"
                  header?: Array<string> | null
                  content?: any
                  summary?: string | null
                  type?: string | null
                }
            > | null
            technicalInput?: Array<{
              __typename: "ExternalDimensioningTechnicalInput"
              name: string
              label?: string | null
              unit?: string | null
              value?: any
              userSelected: boolean
            }> | null
            supplementaryText?: Array<{
              __typename: "ExternalDimensioningSupplementaryText"
              text: string
            }> | null
            transferData?: {
              __typename: "ExternalDimensioningTransferData"
              origin?: string | null
            } | null
          } | null
        }
      | {
          __typename: "Room"
          id: string
          label?: string | null
          number: string
          area?: number | null
          volume?: number | null
          utilization?: string | null
          height?: number | null
          personsNumber?: number | null
          airVolumePerArea?: number | null
          airVolumePerPerson?: number | null
          remark?: string | null
          sup?: number | null
          oda?: number | null
          eta?: number | null
          eha?: number | null
          tra?: number | null
          rca?: number | null
          ida?: number | null
          sec?: number | null
          soundPressureLevel?: number | null
          position: number
          createdAt: string
          updatedAt: string
          hasClarificationRequest?: boolean | null
          children?: Array<{
            __typename: "ProductPosition"
            id: string
            label?: string | null
            variantKey: string
            configurationKey?: string | null
            remark?: string | null
            quantity: number
            position: number
            displayPosition?: string | null
            isAlternative?: boolean | null
            price?: number | null
            priceGroup?: string | null
            hasClarificationRequest?: boolean | null
            references?: Array<{
              __typename: "ProductPositionInstallationReference"
              id: string
              title?: string | null
              permalink: string
              position: number
            }> | null
            addons?: Array<{
              __typename: "ProductPositionAddon"
              id: string
              variantKey: string
              parentProductType: string
            }> | null
            dimensioning?: {
              __typename: "ExternalDimensioningResult"
              transactionId: string
              environmentalVars?: Array<any> | null
              variantKeyData?: any
              dllVersion?: string | null
              language?: string | null
              technicalData?: Array<
                | {
                    __typename: "ExternalDimensioningTechnicalDataDllVersion"
                    dllVersion: string
                  }
                | {
                    __typename: "ExternalDimensioningTechnicalDataTable"
                    header?: Array<string> | null
                    content?: any
                    summary?: string | null
                    type?: string | null
                  }
              > | null
              technicalInput?: Array<{
                __typename: "ExternalDimensioningTechnicalInput"
                name: string
                label?: string | null
                unit?: string | null
                value?: any
                userSelected: boolean
              }> | null
              supplementaryText?: Array<{
                __typename: "ExternalDimensioningSupplementaryText"
                text: string
              }> | null
              transferData?: {
                __typename: "ExternalDimensioningTransferData"
                origin?: string | null
              } | null
            } | null
          }> | null
        }
    > | null
  } | null
}

export const FavoritesProjectDocument = gql`
  query FavoritesProject {
    project(id: "favorites")
      @rest(type: "Project", endpoint: "favorites", path: "") {
      ...Project
    }
  }
  ${ProjectFragmentDoc}
`

/**
 * __useFavoritesProjectQuery__
 *
 * To run a query within a React component, call `useFavoritesProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoritesProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoritesProjectQuery({
 *   variables: {
 *   },
 * });
 */
export function useFavoritesProjectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FavoritesProjectQuery,
    FavoritesProjectQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FavoritesProjectQuery, FavoritesProjectQueryVariables>(
    FavoritesProjectDocument,
    options
  )
}
export function useFavoritesProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FavoritesProjectQuery,
    FavoritesProjectQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FavoritesProjectQuery,
    FavoritesProjectQueryVariables
  >(FavoritesProjectDocument, options)
}
// @ts-ignore
export function useFavoritesProjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FavoritesProjectQuery,
    FavoritesProjectQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  FavoritesProjectQuery,
  FavoritesProjectQueryVariables
>
export function useFavoritesProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FavoritesProjectQuery,
        FavoritesProjectQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  FavoritesProjectQuery | undefined,
  FavoritesProjectQueryVariables
>
export function useFavoritesProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FavoritesProjectQuery,
        FavoritesProjectQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    FavoritesProjectQuery,
    FavoritesProjectQueryVariables
  >(FavoritesProjectDocument, options)
}
export type FavoritesProjectQueryHookResult = ReturnType<
  typeof useFavoritesProjectQuery
>
export type FavoritesProjectLazyQueryHookResult = ReturnType<
  typeof useFavoritesProjectLazyQuery
>
export type FavoritesProjectSuspenseQueryHookResult = ReturnType<
  typeof useFavoritesProjectSuspenseQuery
>
export type FavoritesProjectQueryResult = Apollo.QueryResult<
  FavoritesProjectQuery,
  FavoritesProjectQueryVariables
>
export const FavoritesDocument = gql`
  query Favorites {
    project(id: "favorites")
      @rest(type: "Project", endpoint: "favoritesProductPositions", path: "") {
      id
      ...ProjectChildren
    }
  }
  ${ProjectChildrenFragmentDoc}
`

/**
 * __useFavoritesQuery__
 *
 * To run a query within a React component, call `useFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoritesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFavoritesQuery(
  baseOptions?: Apollo.QueryHookOptions<FavoritesQuery, FavoritesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FavoritesQuery, FavoritesQueryVariables>(
    FavoritesDocument,
    options
  )
}
export function useFavoritesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FavoritesQuery,
    FavoritesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FavoritesQuery, FavoritesQueryVariables>(
    FavoritesDocument,
    options
  )
}
// @ts-ignore
export function useFavoritesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FavoritesQuery,
    FavoritesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<FavoritesQuery, FavoritesQueryVariables>
export function useFavoritesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FavoritesQuery, FavoritesQueryVariables>
): Apollo.UseSuspenseQueryResult<
  FavoritesQuery | undefined,
  FavoritesQueryVariables
>
export function useFavoritesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FavoritesQuery, FavoritesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FavoritesQuery, FavoritesQueryVariables>(
    FavoritesDocument,
    options
  )
}
export type FavoritesQueryHookResult = ReturnType<typeof useFavoritesQuery>
export type FavoritesLazyQueryHookResult = ReturnType<
  typeof useFavoritesLazyQuery
>
export type FavoritesSuspenseQueryHookResult = ReturnType<
  typeof useFavoritesSuspenseQuery
>
export type FavoritesQueryResult = Apollo.QueryResult<
  FavoritesQuery,
  FavoritesQueryVariables
>
